import { render, staticRenderFns } from "./usersReport.vue?vue&type=template&id=c6b63a22&scoped=true&"
import script from "./usersReport.vue?vue&type=script&lang=js&"
export * from "./usersReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b63a22",
  null
  
)

export default component.exports